var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"landing lg_min-h-screen bg-black relative"},[(_vm.aro)?_c('slice-body',{attrs:{"slices":_vm.aro.landing}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }